import React, { useState } from 'react';
import { connect, ConnectedProps } from 'react-redux';
import {
  Card,
  HelpLink,
  Stack,
} from '@piwikpro/ui-components';
import { errorBoundary } from '@piwikpro/platform';
import { AdministrationState } from '../../../../redux';
import Privileges from './Privileges';
import UserGroups from './UserGroups/UserGroups';
import UserPermissionsList from './UserPermissionsList/UserPermissionsList';
import UserDetailsOverlay from '../UserDetailsOverlay';

const mapStateToProps = (state: AdministrationState) => ({
  user: state.users.details.user.details as NonNullable<
  AdministrationState['users']['details']['user']['details']
  >,
});

const connector = connect(mapStateToProps);

type Props = ConnectedProps<typeof connector>;

const Profile: React.FC<Props> = ({ user }) => {
  const [membershipRevision, setMembershipRevision] = useState(0);
  const onMembershipsChanged = () => {
    setMembershipRevision(revision => revision + 1);
  };

  return (
    <>
      <Stack vertical horizontalAlignment="middle">
        <Stack.Item fill>
          <Card>
            <Privileges />
            {user.attributes.role === 'USER' && (
              <>
                <UserGroups
                  membershipRevision={membershipRevision}
                  onMembershipsChanged={onMembershipsChanged}
                />
                <UserPermissionsList kind="app" membershipRevision={membershipRevision} />
                <UserPermissionsList kind="meta-site" membershipRevision={membershipRevision} />
              </>
            )}
          </Card>
        </Stack.Item>
        <Stack.Item>
          <HelpLink href="https://help.piwik.pro/support/account/add-user/">
            Add and manage users
          </HelpLink>
        </Stack.Item>
      </Stack>
      <UserDetailsOverlay onMembershipsChanged={onMembershipsChanged} />
    </>
  );
};

export default connector(errorBoundary(Profile));
